<script lang="ts">
  import GlobalStyle from "./components/GlobalStyle.svelte"
  import LoadData from "./components/LoadData.svelte"
  import Loading from "./components/Loading.svelte"
  import KeyboardFocus from "./components/KeyboardFocus.svelte";
  import Navigation from "./components/Navigation.svelte"
  let loaded: boolean = false
</script>

<GlobalStyle/>
<KeyboardFocus>
  <LoadData bind:loaded/>
  <main>
    {#if !loaded}
      <Loading/>
    {:else}
      <Navigation/>
    {/if}
  </main>  
</KeyboardFocus>
